const backendBaseUrl = () =>
  new URL(
    import.meta.env.VITE_APP_BACKEND_V2_GET_URL || "/api/v2/",
    window.location.origin,
  );

export const cloudflareApiUrl = (path: string) =>
  new URL(path, backendBaseUrl().origin).toString();

export const cloudflareFetch = (
  input: string,
  init: RequestInit = {},
) =>
  fetch(
    input.startsWith("http://") || input.startsWith("https://")
      ? input
      : cloudflareApiUrl(input),
    {
      ...init,
      credentials: init.credentials ?? "include",
    },
  );
